import { useRef, ReactNode } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  titulo: string;
  descricao: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  // Esquema de cor do botão de confirmação (red pra ações destrutivas).
  colorScheme?: string;
  isLoading?: boolean;
}

// Confirmação pra ações irreversíveis das telas de Cobrança (cancelar boleto na
// BMP, excluir contato / negociação). Mesmo AlertDialog do DeleteButton, sem a
// navegação/toast embutidos: quem chama decide o que fazer no `onConfirm` e
// quando fechar.
export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  titulo,
  descricao,
  confirmLabel = "Confirmar",
  cancelLabel = "Voltar",
  colorScheme = "red",
  isLoading = false,
}: ConfirmDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent fontFamily="Lexend Deca">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {titulo}
          </AlertDialogHeader>

          <AlertDialogBody fontSize="sm">{descricao}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} isDisabled={isLoading} size="sm">
              {cancelLabel}
            </Button>
            <Button colorScheme={colorScheme} onClick={onConfirm} ml={3} size="sm" isLoading={isLoading}>
              {confirmLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
